import { useIsMdOrGreater } from '@dreamstack/feature-components/src/hooks/useWindowSize'
import { useCallback } from 'react'

export const useGraphFontsize = () => {
  const md = useIsMdOrGreater()
  const graphFontSize = md ? 16 : 12
  return graphFontSize
}

export const useGraphFontsizeCb = () => {
  const md = useIsMdOrGreater()
  return useCallback(() => {
    const graphFontSize = md ? 16 : 12
    return graphFontSize
  }, [md])
}
